
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { AuthGuard } from 'src/app/auth.guard';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.scss']
})
export class BlankComponent implements OnInit
{

  public title: string = 'Page title goes here';
  public description: string = 'Description goes here. This is optional depending on the page.  Same goes for the icon. Remove attribute in HTML is not needed.';
  public settings: Settings;

  constructor(
    private activatedRoute: ActivatedRoute,
    private appSettings: AppSettings,
    private authGuard: AuthGuard,
    private sharedService: SharedService) { }

  /////////////////////////////////////////////////////////////////////////
  async ngOnInit()
  {

    //Standard ngOnInit code for each page
    //************************************
    this.settings = this.appSettings.settings;
    //if (!this.authGuard._canActivate()) return;

    //************************************

    this.getData();

  }

  /////////////////////////////////////////////////////////////////////////
  async getData()
  {


  }

}



